import { render, staticRenderFns } from "./SubscriptionRenewal.vue?vue&type=template&id=08c0b005&scoped=true&"
import script from "./SubscriptionRenewal.vue?vue&type=script&lang=js&"
export * from "./SubscriptionRenewal.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionRenewal.vue?vue&type=style&index=0&id=08c0b005&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c0b005",
  null
  
)

export default component.exports